import { Config } from '@leverege/plugin'

export default {
  id : 'dt.action.OpenEventEndVideoUrl',
  matches : {
    client : 'LinearViewBlock'
  },
  layout : {
    group : [ 'Video', 'End' ],
    groupIcons : [ 'fa fa-fw fa-video-camera' ]
  },
  appearance : ( { context } ) => ( {
    name : `Open (Offset: ${context.item.stopData.videoOffset.toFixed( 2 )})`,
    icon : 'fa fa-fw fa-external-link'
  } ),
  handles : ( context ) => {
    const { item } = context
    
    return item?.stopData != null
  },
  perform : ( { context } ) => {
    const { item } = context
    const videoBucketUrl = Config.get( 'LinearViewBlock', 'gcsVideoBucketUrl' )
    window.open( `${videoBucketUrl}/${item.stopData.videoPath}`, '_blank' ).focus()
  }
}
